/* Dear Apothecary product blocks: ingredient spotlight carousel + timeline rail fit.
   Markup lives in each product template (custom liquid). This file only adds behaviour. */
(function(){
  function tween(el,to){var from=el.scrollLeft,d=to-from,t0=Date.now(); if(Math.abs(d)<2){el.scrollLeft=to;return;} el.dataset.daTween='1';
    (function step(){var p=Math.min(1,(Date.now()-t0)/380); p=1-Math.pow(1-p,3); el.scrollLeft=from+d*p; if(p<1)setTimeout(step,16); else setTimeout(function(){delete el.dataset.daTween;},120);})();}

  function spot(sec){
    var q=function(c){return sec.querySelector(c)};
    var track=q('.da-spot__track'), bar=q('.da-spot__bar'), thumbs=q('.da-spot__thumbs'), text=q('.da-spot__text');
    if(!track||!text)return;
    var S=[].slice.call(track.children), N=S.length, cur=0, timer;
    function paint(i){
      var it=S[i].dataset;
      q('.da-spot__name').textContent=it.name||''; var d=q('.da-spot__dose'); d.textContent=it.dose||''; d.style.display=it.dose?'':'none';
      q('.da-spot__latin').textContent=it.latin||''; q('.da-spot__what').textContent=it.what||''; q('.da-spot__why').textContent=it.why||'';
      var c=q('.da-spot__count'); if(c)c.textContent=(i+1)+' / '+N;
      var a=q('.da-spot__arrow[data-dir="-1"]'), b=q('.da-spot__arrow[data-dir="1"]'); if(a)a.disabled=(i===0); if(b)b.disabled=(i===N-1);
      S.forEach(function(s,k){s.classList.toggle('is-on',k===i)});
      if(bar)[].forEach.call(bar.children,function(s,k){s.classList.toggle('is-on',k===i)});
      if(thumbs)[].forEach.call(thumbs.children,function(s,k){s.classList.toggle('is-on',k===i); if(k===i) tween(thumbs,s.offsetLeft-thumbs.offsetLeft-(thumbs.clientWidth-s.clientWidth)/2)});
    }
    function go(i,scroll){
      i=Math.max(0,Math.min(N-1,i)); if(i===cur)return;
      text.classList.add('is-fading'); setTimeout(function(){cur=i;paint(i);text.classList.remove('is-fading');},180);
      if(scroll!==false){var s=S[i]; tween(track,s.offsetLeft-track.offsetLeft-(track.clientWidth-s.clientWidth)/2);}
    }
    sec.addEventListener('click',function(e){
      var a=e.target.closest('.da-spot__arrow'); if(a){go(cur+ +a.dataset.dir);return;}
      var t=e.target.closest('.da-spot__thumbs button'); if(t){go(+t.dataset.i);return;}
      var s=e.target.closest('.da-spot__slide'); if(s&&+s.dataset.i!==cur){go(+s.dataset.i);}
    });
    var armed=false; ['pointerdown','touchstart','wheel','keydown'].forEach(function(ev){sec.addEventListener(ev,function(){armed=true;},{passive:true});});
    track.addEventListener('scroll',function(){if(track.dataset.daTween)return; if(!armed){track.scrollLeft=0;return;} clearTimeout(timer);timer=setTimeout(function(){
      var c=track.scrollLeft+track.clientWidth/2,best=0,bd=1e9;
      S.forEach(function(s,k){var d=Math.abs(s.offsetLeft-track.offsetLeft+s.clientWidth/2-c); if(d<bd){bd=d;best=k}});
      if(best!==cur) go(best,false);
    },80)},{passive:true});
    /* lock the text block to the tallest ingredient so swiping never shifts the page */
    function lockH(){var h=0,keep=cur; text.style.minHeight='0'; S.forEach(function(it,k){paint(k); h=Math.max(h,text.offsetHeight);}); paint(keep); text.style.minHeight=h+'px';}
    lockH(); window.addEventListener('load',lockH); var rt; window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(lockH,150);});
  }

  function timeline(tl){
    var line=tl.querySelector('.da-tl__line'), dots=tl.querySelectorAll('.da-tl__dot');
    function fit(){ if(!line||dots.length<2)return; if(window.innerWidth>900){line.style.top='';line.style.height='';line.style.bottom='';return;}
      var tr=tl.querySelector('.da-tl__track').getBoundingClientRect(), a=dots[0].getBoundingClientRect(), z=dots[dots.length-1].getBoundingClientRect();
      var top=a.top+a.height/2-tr.top, bot=z.top+z.height/2-tr.top; line.style.top=top+'px'; line.style.height=(bot-top)+'px'; line.style.bottom='auto'; }
    fit(); window.addEventListener('load',fit); var t; window.addEventListener('resize',function(){clearTimeout(t);t=setTimeout(fit,150);});
  }

  function run(){
    document.querySelectorAll('.da-spot').forEach(spot);
    document.querySelectorAll('.da-tl').forEach(timeline);
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',run);}else{run();}
})();
